import type { ReactNode } from 'react';
import { Typography, Space } from 'antd';

const { Title, Text } = Typography;

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  extra?: ReactNode;
}

/**
 * Standard page header — Title + optional subtitle + right-aligned actions.
 * Used by every page so spacing and typography stay consistent.
 */
export function PageHeader({ title, subtitle, extra }: PageHeaderProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 16,
        marginBottom: 8,
      }}
    >
      <Space direction="vertical" size={2} style={{ minWidth: 0 }}>
        <Title level={3} style={{ margin: 0, fontWeight: 600 }}>
          {title}
        </Title>
        {subtitle ? (
          <Text type="secondary" style={{ fontSize: 13 }}>
            {subtitle}
          </Text>
        ) : null}
      </Space>
      {extra ? <div style={{ flexShrink: 0 }}>{extra}</div> : null}
    </div>
  );
}
